import { FirebaseDocChangeType, FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { BasketType } from 'types/basket'
import { mergeListeningBaskets } from 'reducks/basket/operations'
import { setBasketUnsubscribesAction } from 'reducks/basket/actions'

const fetchBaskets = (date: string, storeRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    // リスナーが設定済み（unsubscribeがセットされている）であればスキップ（二重取得の防止）
    if (getState().basket.is_set_unsubscribe) return
    const unsubscribe = await storeRef
      .collection('store_baskets')
      .where('date', '==', date)
      .orderBy('basket_number', 'asc')
      .onSnapshot((snapshots) => {
        // データの追加のみ監視する
        const changes = snapshots.docChanges().filter((change: FirebaseDocChangeType) => change.type === 'added')
        const currentBaskets: BasketType[] = getState().basket.baskets
        mergeListeningBaskets(changes, currentBaskets, dispatch)
      })
    dispatch(setBasketUnsubscribesAction([unsubscribe]))
  }
}

export default fetchBaskets
